/**
 * A name in the change list that opens that thing's own page - issue #102.
 *
 * `to` is decided by the caller from the one shared rule (`elementLink`,
 * `requirementPage` in elementThreads.ts), the same one the comment button
 * follows. Null means the row has nowhere to go - a removed element, a kind with
 * no page - and the text is drawn exactly as it was, not as a dead link.
 */

import type { ReactNode } from 'react'
import { Link as RouterLink, useInRouterContext } from 'react-router-dom'
import Link from '@mui/material/Link'

interface Props {
  to: string | null
  children: ReactNode
}

/**
 * Inside the app there is always a router. A list drawn outside one (a test of
 * a screen that holds it, say) draws the plain text rather than failing to draw,
 * as ElementCommentButton does.
 */
export default function ChangeLink({ to, children }: Props) {
  const inRouter = useInRouterContext()
  if (!to || !inRouter) return <>{children}</>
  return (
    <Link component={RouterLink} to={to} underline="hover" color="inherit">
      {children}
    </Link>
  )
}
